import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AsyncJobDialogBase } from '../async-job-base/async-job-base.dialog';
import { AsyncJobService } from '../../services/async-job.service';
import { SiteETLService } from '../../services/site-etl.service';
import { CurrentSiteService } from '../../services/current-site.service';
import { AsyncJob } from '../../models/async-job.model';

@Component({
    selector: 'app-get-site-etl-metadata',
    templateUrl: './get-site-etl-metadata.dialog.html',
    styleUrls: ['./get-site-etl-metadata.dialog.scss'],
    standalone: false
})
export class GetSiteEtlMetadataDialog extends AsyncJobDialogBase implements OnInit {
    // Properties.
    private downloadExportedDataUrl: string = null;
    private jobErrorMessage: string = null;

    // Constructor.
    public constructor(private dialogRef: MatDialogRef<GetSiteEtlMetadataDialog>,
        asyncJobService: AsyncJobService,
        private siteETLService: SiteETLService,
        private currentSiteService: CurrentSiteService) {
        super(asyncJobService);
    }

    // Life cycle methods.
    public ngOnInit(): void {
    }

    // Immplement base class abstract methods.
    public get ComponentClassName(): string {
        return 'GetSiteETlMetadataDialog';
    }

    // Methods called by my HTML code.
    public get JobTimeElapsedCssClass(): string {
        return (this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span');
    }

    public get ExportStatus(): string {
        let status: string = null;

        if ((!this.jobInProgress) && (this.asyncJobInfo == null)) {
            status = 'Not started';
        } else if (this.jobInProgress) {
            status = 'ETL metadata generation in progress';
        } else if (!this.jobErrorOccurred) {
            status = "Click 'Download' to save ETL metadata";
        } else {
            //status = 'An export error occurred';
            status = this.jobErrorMessage;
        }

        return (status);
    }

    public get DownloadExportedDataUrl(): string {
        return this.downloadExportedDataUrl;
    }

    // Handle control events.
    public generatSiteETLMetadataClicked(): void {
        this.siteETLService.generateSiteETLJob(this.currentSiteService.Site.id).then(response => {
            let asyncJob: AsyncJob = response; // resultHash['asyncJob'];
            this.startMonitoringJob(asyncJob, this.jobCompletedArrowFunction);
        });
    }

    /*
    public downloadSiteETLMetadataClicked(): void {
        // TO DO:  CODE THIS METHOD.
    }
    */

    public cancelClicked(): void {
        this.dialogRef.close(null);
    }

    // Private helper methods.
    private jobCompletedArrowFunction = (asyncJob: AsyncJob): void => {
        if (asyncJob.status == AsyncJob.STATUS_COMPLETE) {
            let expectedFileName: string = `site_${this.currentSiteService.Site.id}_etl_metadata.json`;
            this.downloadExportedDataUrl = this.siteETLService.getResultFileDownloadUrl(asyncJob, expectedFileName);
        }
        else if (asyncJob.status == AsyncJob.STATUS_COMPLETE_ERROR) {
            if ((asyncJob.stdError != null) && (asyncJob.stdError.trim() != "")) {
                this.jobErrorMessage = asyncJob.stdError;
            } else {
                this.jobErrorMessage = "The job failed but without providing additional error information.";
            }

        }

        /*
        if (asyncJob.stdOut) {
            this.validationMessages = asyncJob.stdOut;
        }
        */
    }
}
